import { render, staticRenderFns } from "./NotificationFeedSection.vue?vue&type=template&id=26d62318&scoped=true"
import script from "./NotificationFeedSection.vue?vue&type=script&lang=js"
export * from "./NotificationFeedSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d62318",
  null
  
)

export default component.exports